module.exports = __webpack_public_path__ + "static/favicon-f339f898f9ff0c4b56f7eb1276b7e1a1.ico";